import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import BarcodeGenerator from "./BarCode";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import uRLs from "../../../utils/baseUtils";
import EditProduct from "./EditProduct";
import Messages from "../../../constants/Messages";
import { usePermission } from "../../../context/PermissionContext";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "../../../constants/Table";
import AddProductModal from "./AddProductModal";
import ProductOverView from "./ProductOverView";
import { toPrimaryQuantity } from "@heartinz/finance";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { AddIcon, ArrowBackIcon, BarcodeIcon, EditIcon } from "../../../constants/Icons";

const Product = ({ isActive, onDone }) => {
  const [isLoading, setIsLoading] = useState(true);
  const hasFetched = useRef(false);
  const containerRef = useRef(null);
  const [isProductData, setProductData] = useState([]);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const [AddproductModalOpen, setAddProductModalOpen] = useState(true);
  const [productStockData, setPrductStockData] = useState([]);
  const [productData, setPrductData] = useState([]);
  const [productViewOpen, setProductViewOpen] = useState(false);
  const addProductBtnRef = useRef(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [noteSuggest, setNoteSuggest] = useState([]);
  const { permission, hasPermission, globelPopupOpen } = usePermission();
  const [noteOpen, setNoteOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [brandSuggest, setBrandSuggest] = useState([]);
  const [isAnyInputFocused, setIsAnyInputFocused] = useState(false);
  const { navigatelist } = location?.state || {};
  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const closeAddModal = () => {
    setAddProductModalOpen(false);
  };

  const handleCloseProductView = () => {
    setProductViewOpen(false);
  };

  const primaryQuanity = (quanity, unitData) => {
    const qty = toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  };

  const handleStockDetails = async (product) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/stock/primary-store/${product._id}`,
      );
      const products = response.data?.results;
      setPrductStockData(products);
      // if (products.length > 0) {
      //   setStockModalOpen(true);
      //   matchOpen(true);
      //   setStockData(products);

      //   setSearchTerm("");
      //   setProductSugesstions([]);
      //   searchOpen(false);
      // } else {
      //   showAlert("warning", Messages.ERROR.NO_STOCK);
      // }
    } catch (error) {
      setPrductStockData();
      // handleError(error, showAlert);
    }
  };

  const handleOpenProductView = async (product) => {
    console.log(product);
    setPrductData(product);
    await handleStockDetails(product);
    setProductViewOpen(true);
  };

  const hadlEditStockData = (updatedData, stockData, quantity) => {
    const totalStock = stockData?.reduce(
      (total, item) => total + (item?.stockLeft || 0),
      0,
    );
    setProductData((prevProductData) =>
      prevProductData.map((product) =>
        product._id === updatedData?.productid
          ? {
              ...product,
              totalStockLeft:
                totalStock +
                Number(
                  updatedData?.stockLinkInfo?.isSecondaryUnit
                    ? primaryQuanity(
                        quantity,
                        updatedData?.stockLinkInfo?.unitConfig,
                      )
                    : quantity,
                ),
            }
          : product,
      ),
    );
  };

  const hadlTrashStockData = (updatedData, stockData, quantity) => {
    const totalStock = stockData?.reduce(
      (total, item) => total + (item?.stockLeft || 0),
      0,
    );
    setProductData((prevProductData) =>
      prevProductData.map((product) =>
        product._id === updatedData?.productid
          ? {
              ...product,
              totalStockLeft:
                totalStock -
                Number(
                  updatedData?.stockLinkInfo?.isSecondaryUnit
                    ? primaryQuanity(
                        quantity,
                        updatedData?.stockLinkInfo?.unitConfig,
                      )
                    : quantity,
                ),
            }
          : product,
      ),
    );
  };

  const handleDeteleDataUpdate = (deletedProduct) => {
    console.log(deletedProduct);
    setProductData((prev) =>
      prev.filter((item) => item._id !== deletedProduct?._id),
    );

    setPrductData(null);
    setPrductStockData([]);
    setProductViewOpen(false);
  };

  const handleNoteOpen = (status) => {
    setNoteOpen(status);
  };
  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleUpdte = async (updatedData, imageFile, trigger = true) => {
    const original = isEditData;

    const formData = new FormData();
    let isDataChanged = false;

    const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
      if (newVal !== oldVal) {
        formData.append(key, transform(newVal));
        isDataChanged = true;
      }
    };

    const isPriceGroupChanged =
      updatedData?.mrp !== original?.mrp ||
      updatedData?.saleprice !== original?.saleprice ||
      updatedData?.baseprice !== original?.baseprice ||
      updatedData?.taxpercentage !== original?.taxpercentage ||
      updatedData?.isLock !== original?.isLock;

    if (isPriceGroupChanged) {
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
      );
      formData.append("taxpercentage", updatedData?.taxpercentage);
      formData.append("isLock", updatedData?.isLock);

      isDataChanged = true;
    }

    appendIfChanged("code", updatedData?.code, original?.code);
    appendIfChanged(
      "hsnsac",
      updatedData?.hsnsac ?? "",
      original?.hsnsac ?? "",
    );
    appendIfChanged("title", updatedData?.title, original?.title);
    // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
    // appendIfChanged("isLock", updatedData.isLock, original.isLock);
    appendIfChanged("note", updatedData?.note, original?.note);
    appendIfChanged(
      "searchTag",
      updatedData?.searchTag ?? "",
      original?.searchTag ?? "",
    );
    appendIfChanged(
      "shortName",
      updatedData?.shortName ?? "",
      original?.shortName ?? "",
    );
    appendIfChanged(
      "brandId",
      updatedData?.brandData?.title ?? "",
      original?.brandId ?? "",
    );
    // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    appendIfChanged(
      "landingcost",
      updatedData?.landingcost || 0,
      original?.landingcost || 0,
      (v) => CurrencyConverter.toSubunit(v, "INR"),
    );

    const newUnit = updatedData?.unitConfig;
    const oldUnit = original?.unitConfig;

    if (
      !updatedData?.unitLocked &&
      JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
    ) {
      formData.append("unitConfig", JSON.stringify(newUnit));
      isDataChanged = true;
    }
    if (imageFile instanceof File) {
      formData.append("primaryImage", imageFile);
      isDataChanged = true;
    }

    if (!isDataChanged) {
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      if (trigger) closeEditModal();
      return true;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.patch(
        `module/product/update-product/${updatedData._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);

      setProductData((prev) =>
        prev.map((p) =>
          p._id === response.data.results?._id ? response.data.results : p,
        ),
      );

      if (trigger) closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  // const handleUpdte = async (updatedData, imageFile, trigger = true) => {
  //   const originalDataForComparison = isEditData;
  //   let isDataChanged = false;
  //   if (
  //     updatedData.code !== originalDataForComparison.code ||
  //     updatedData.hsnsac !== originalDataForComparison.hsnsac ||
  //     updatedData.title !== originalDataForComparison.title ||
  //     updatedData.taxpercentage !== originalDataForComparison.taxpercentage ||
  //     updatedData.isLock !== originalDataForComparison.isLock ||
  //     updatedData.note !== originalDataForComparison.note ||
  //     updatedData?.searchTag !== originalDataForComparison?.searchTag||
  //     updatedData?.brandData?.title!=originalDataForComparison?.brandId
  //   ) {
  //     isDataChanged = true;
  //   }

  //   if (
  //     !isDataChanged &&
  //     (updatedData.mrp !== originalDataForComparison.mrp ||
  //       updatedData.saleprice !== originalDataForComparison.saleprice ||
  //       updatedData.baseprice !== originalDataForComparison.baseprice ||
  //       updatedData.landingcost !== originalDataForComparison.landingcost)
  //   ) {
  //     isDataChanged = true;
  //   }

  //   if (
  //     !isDataChanged &&
  //     (updatedData?.unitConfig?.primaryUnitName !==
  //       originalDataForComparison?.unitConfig?.primaryUnitName ||
  //       updatedData?.unitConfig?.primaryUnitCode !==
  //         originalDataForComparison?.unitConfig?.primaryUnitCode ||
  //       updatedData?.unitConfig?.secondaryUnitName !==
  //         originalDataForComparison?.unitConfig?.secondaryUnitName ||
  //       updatedData?.unitConfig?.secondaryUnitCode !==
  //         originalDataForComparison?.unitConfig?.secondaryUnitCode ||
  //       updatedData?.unitConfig?.conversion !==
  //         originalDataForComparison?.unitConfig?.conversion)
  //   ) {
  //     isDataChanged = true;
  //   }

  //   if (!isDataChanged && imageFile instanceof File) {
  //     isDataChanged = true;
  //   }

  //   if (!isDataChanged) {
  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //     if (trigger) {
  //       closeEditModal();
  //     }
  //     return true;
  //   }
  //   setBtnLoading(true);
  //   try {
  //     if (!checkNetwork()) return;
  //     // var data = {
  //     //   // productid: updatedData._id,
  //     //   code: updatedData.code,
  //     //   hsnsac: updatedData.hsnsac,
  //     //   title: updatedData.title,
  //     //   mrp: CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
  //     //   saleprice: CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
  //     //   taxpercentage: updatedData.taxpercentage,
  //     //   // discount: CurrencyConverter.toSubunit(updatedData.discount, "INR"),
  //     //   baseprice: CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
  //     //   // taxamount: CurrencyConverter.toSubunit(updatedData.taxamount, "INR"),
  //     //   isLock: updatedData.isLock,
  //     //   landingcost: CurrencyConverter.toSubunit(updatedData.landingcost, "INR"),
  //     //   note:updatedData.note,
  //     // };

  //     const formData = new FormData();
  //     formData.append("code", updatedData.code);
  //     formData.append("hsnsac", updatedData?.hsnsac ?? "");
  //     formData.append("title", updatedData.title);
  //     formData.append(
  //       "mrp",
  //       CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
  //     );
  //     formData.append(
  //       "saleprice",
  //       CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
  //     );
  //     formData.append("taxpercentage", updatedData.taxpercentage);

  //     formData.append(
  //       "baseprice",
  //       CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
  //     );
  //     formData.append("isLock", updatedData.isLock);
  //     formData.append(
  //       "landingcost",
  //       CurrencyConverter.toSubunit(updatedData.landingcost || 0, "INR"),
  //     );
  //     formData.append(
  //       "searchTag", updatedData?.searchTag??" ",
  //     )
  //     if(updatedData?.brandData?.title){
  //     formData.append("brandId",updatedData?.brandData?.title)}
  //     formData.append("note", updatedData.note);
  //     if (updatedData?.unitConfig && !updatedData?.unitLocked) {
  //       formData.append("unitConfig", JSON.stringify(updatedData?.unitConfig));
  //     }

  //     //  Append file only if it exists
  //     if (imageFile instanceof File) {
  //       formData.append("primaryImage", imageFile);
  //     } else {
  //       console.log("No image selected or wrong data type:", imageFile);
  //     }

  //     const response = await AxiosInstance.patch(
  //       `module/product/update-product/${updatedData._id}`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       },
  //     );
  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //     setProductData((prevProductData) =>
  //       prevProductData.map((product) =>
  //         product._id === response.data.results?._id
  //           ? response.data.results
  //           : product,
  //       ),
  //     );
  //     if (trigger) {
  //       closeEditModal();
  //     }
  //     return true;
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  const handleRecentProduct = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/recent-products`,
      );
      setProductData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetRecentProducts = (product) => {
    setProductData((prev) => [product, ...prev.slice(0, prev.length - 1)]);
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleProductAdded = (product) => {
    handleSetRecentProducts(product);
    handleOpenProductView(product);
    // Close current modal
    setAddProductModalOpen(false);

    // Immediately open a fresh one
    setTimeout(() => {
      setAddProductModalOpen(true);
    }, 5000);
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleBrandSuggest = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/brand/suggestion`,
      );
      const result = response?.data?.results;
      setBrandSuggest(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  useEffect(() => {
    if (!isActive || !containerRef.current) return;

    const root = containerRef.current;

    const handleArrowAndEnter = (e) => {
      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      if (
        isEditModalOpen ||
        showBarcodeModal ||
        noteOpen ||
        globelPopupOpen ||
        isAnyInputFocused
      )
        return;

      e.preventDefault();

      // ✅ ONLY Product table rows
      const tableRows = Array.from(root.querySelectorAll("table tbody tr"));

      if (!tableRows.length) return;

      const currentRow = document.activeElement?.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Enter
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset?.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) openEditModal(item);
        }
        return;
      }

      // No row focused yet
      if (currentIndex === -1) {
        const startIndex = e.key === "ArrowUp" ? tableRows.length - 1 : 0;

        tableRows[startIndex].tabIndex = 0;
        tableRows[startIndex].focus();
        return;
      }

      tableRows[currentIndex].tabIndex = -1;

      const nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    isActive,
    showBarcodeModal,
    isEditModalOpen,
    noteOpen,
    globelPopupOpen,
    isAnyInputFocused,
  ]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleRecentProduct();
    handleSuggestNote();
    handleBrandSuggest();
  }, []);

  useEffect(() => {
    setAddProductModalOpen(true);
  }, []);

  const handleBack = () => {
    navigate(navigatelist || "/dashboard");
    onDone?.();
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="row">
            <div className="col-lg-5">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-primary text-right"
                  onClick={handleBack}
                >
                  <ArrowBackIcon/>
                </button>
                <h6 className="card-title ms-2">Add Product</h6>
              </div>
              <div className="d-flex justify-content-center align-items-center flex-column mt-5">
                <button
                  type="button"
                  className="btn btn-primary text-center mt-3"
                  onClick={() => setAddProductModalOpen(true)}
                  ref={addProductBtnRef}
                >
                  <AddIcon/> New Product
                </button>
              </div>
            </div>
            <div className="col-lg-7">
              {(hasPermission("PRODUCT", "PRODUCT:viewRecent") ||
                permission === undefined) && (
                <>
                  <h6 className="card-title ">Recently Added Products</h6>
                  <div className="card radius-10 mb-0 mt-3">
                    <div className="card-body px-0">
                      <div ref={containerRef}>
                        <Table
                          loading={isLoading}
                          data={isProductData}
                          onRowClick={(item) => openEditModal(item)}
                          columns={[
                            {
                              label: "S.No",
                              render: (_, index) =>
                                isProductData.length - index,
                            },
                            {
                              label: "SKU Code",
                              render: (item) => (
                                <span className="badge rounded-pill bg-label-navy">
                                  {item.code}
                                </span>
                              ),
                            },
                            {
                              label: "Title",
                              tdBodyclass:"text-align-left-force",
                              render: (item) => (
                                <span className="text-heading fw-medium text-wrap">
                                  {item.title}
                                </span>
                              ),
                            },
                            {
                              label: "MRP",
                              render: (item) => (
                                <span className="text-right">
                                  {formatCurrencyFun(item?.mrp)}
                                </span>
                              ),
                            },
                            {
                              label: "Sale Price",
                              render: (item) => (
                                <span className="text-right">
                                  {formatCurrencyFun(item?.saleprice)}
                                </span>
                              ),
                            },
                            {
                              label: "Tax(%)",
                              render: (item) => (
                                <span className="badge rounded-pill bg-label-peace">
                                  {item.taxpercentage}%
                                </span>
                              ),
                            },
                            {
                              label: "LandingCost",
                              render: (item) => (
                                <span className="text-right ">
                                {formatCurrencyFun(item?.landingcost)}
                                </span>
                              ),
                            },
                            {
                              label: "Unit",
                              render: (item) => (
                                <span className="badge btn-unit">
                                  {item?.unitConfig?.primaryUnitCode}
                                  {/* {item?.unitConfig?.primaryUnitCode==="unit"?"": item?.unitConfig?.primaryUnitCode} */}
                                </span>
                              ),
                            },
                            {
                              label: "Actions",
                              render: (item) => (
                                <div className="order-actions opacity-0 opacity-md-100">
                                  <button
                                    type="button"
                                    className="btn-label-primary shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickBarcode(item);
                                    }}
                                  >
                                    <BarcodeIcon/>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-label-primary shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openEditModal(item);
                                    }}
                                  >
                                    <EditIcon/>
                                  </button>
                                </div>
                              ),
                            },
                          ]}
                        />
                      </div>
                      {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
                        <BarcodeGenerator
                          barcodeValue={selectedBarcode.code}
                          product={selectedBarcode}
                          onClose={() => setShowBarcodeModal(false)}
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {AddproductModalOpen && (
          <AddProductModal
            isActive={isActive}
            ListRecentProduct={handleRecentProduct}
            handleSetRecentProducts={handleSetRecentProducts}
            noteOpenStatus={handleNoteOpen}
            noteSuggests={noteSuggest}
            navigatelist={handleBack}
            setIsAnyInputFocused={setIsAnyInputFocused}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
            editData={isEditData}
            onClose={closeAddModal}
            onEdit={handleUpdte}
            isBtnLoad={isBtnLoading}
            isEditModalOpen={isEditModalOpen}
            setEditModalOpen={setEditModalOpen}
            setEditData={setEditData}
            onProductAdded={handleProductAdded}
          />
        )}
        {isEditModalOpen && (
          <EditProduct
            isActive={isActive}
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdte}
            isBtnLoading={isBtnLoading}
            noteSuggests={noteSuggest}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}

        {productViewOpen && (
          <ProductOverView
            onClose={handleCloseProductView}
            onData={productData}
            onStockData={productStockData}
            onUpdate={handleUpdte}
            noteSuggests={noteSuggest}
            isBtnLoading={isBtnLoading}
            setProductData={setProductData}
            onStockEditData={hadlEditStockData}
            OnStockTrashData={hadlTrashStockData}
            handleDeteleDataUpdate={handleDeteleDataUpdate}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}
      </div>
    </div>
  );
};
export default Product;
